import languageJson from "./language.json";
import regionJson from "./regions.json";
import officeJson from "./offices.json";
import provinceJson from "./provinces.json";

// Goto https://www.w3schools.com/JSREF/jsref_tolocalestring.asp to find the date style for your country.
export const dateStyle = "en-US";

export const language = languageJson;
export const offices = officeJson;
export const regions = regionJson;
export const provinces = provinceJson;
